/* eslint-disable no-magic-numbers -- surface tokens are named by number */
import { css, FlattenSimpleInterpolation } from 'styled-components';
import { mainTheme } from '../themes/mainTheme';

export const labelVariants = <const> [
	'neutral',
	'informational',
	'success',
	'warning',
	'critical',
	'secondary',
];

export type LabelVariant = typeof labelVariants[number];

// Soft chips: a dark fill with its matching light text token.
export const LabelVariantCssDefinition: { [key in LabelVariant]: FlattenSimpleInterpolation } = {
	neutral: css`
		background-color: ${mainTheme.surface[4]};
		color: ${mainTheme.text.primary};
	`,
	informational: css`
		background-color: ${mainTheme.surface[4]};
		color: ${mainTheme.text.primary};
	`,
	success: css`
		background-color: ${mainTheme.fill.success};
		color: ${mainTheme.text.success};
	`,
	warning: css`
		background-color: ${mainTheme.fill.warning};
		color: ${mainTheme.text.warning};
	`,
	critical: css`
		background-color: ${mainTheme.fill.danger};
		color: ${mainTheme.text.danger};
	`,
	secondary: css`
		background-color: ${mainTheme.fill.dimmed};
		color: ${mainTheme.text.secondary};
	`
};
